<banner-app [Fixtop]="''" [retroSelected]="false" [infoDueno]="true"  [showPromo]="true"></banner-app>

<div class="page-container">
  <div class="container">
    <div class="content-wrapper d-flex flex-column align-items-center">
      
      <div class="text-content text-center">
        <h2 class="page-title">¡Ya tienes una póliza activa!</h2>
        <p class="page-subtitle">
          Hemos revisado tu situación y parece que ya tienes una póliza activa asociada a ese documento de identidad y placa.
        </p>
        <p class="page-subtitle">
          Si necesitas hacer cambios en tu póliza actual o tienes preguntas sobre ella, no dudes en ponerte en contacto con nosotros.
        </p>
      </div>

      <img src="./assets/img/Pareja.png" alt="Ilustración de pareja protegida" class="content-image">
      
      <div class="action-button-container">
        <button class="btn btn-primary action-button" type="button" (click)="volverAlInicio()">
          Volver al inicio
        </button>
      </div>

    </div>
  </div>
</div>

<app-footer-app class="footer-fixed" />